import gsap from 'gsap';
import Tools from './../components/tools';

export default class Team {
  constructor() {
    const tools = new Tools();

    const teamItems = document.querySelectorAll('.team__item');
    if (teamItems.length > 0) {
      teamItems.forEach((item) => {
        item.querySelector('.team__more').addEventListener('click', () => {
          item.classList.toggle('open');
          if (item.classList.contains('open')) {
            item.querySelector('.team__more').innerText = 'refermer';
            item.querySelector('.team__more').dataset.content = 'refermer';
            tools.fixedToAuto( item.querySelector('.text-container') );
          } else {
            item.querySelector('.team__more').innerText = 'lire la suite';
            item.querySelector('.team__more').dataset.content = 'lire la suite';
            tools.autoToFixed( item.querySelector('.text-container') );
          }
        });
      });
    }
  }
}